import { ChatBubbleOutline } from "@mui/icons-material";
import { Box, Typography, styled } from "@mui/material";
import React from "react";

const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
  text-align: center;
`;

const EmptyIcon = styled(ChatBubbleOutline)`
  font-size: 48px;
  color: #667781;
  margin-bottom: 16px;
`;

interface EmptyStateProps {
  message?: string;
  showIcon?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message = "Nenhuma mensagem ainda",
  showIcon = true,
}) => {
  return (
    <EmptyStateContainer>
      {showIcon && <EmptyIcon />}
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </EmptyStateContainer>
  );
};

export default EmptyState;
